/* STEP 12-2 · lane S12B (owner card Step 12 V4, section B — running note numbers per engagement) — EN + AR of
   the "Not presented" list on the IFRS notes tab (the empty notes, collapsed, each with its "include" tick; NoteNumbers.jsx),
   the report banner "Note numbers changed since this version — regenerate" (a draft generated before the map changed), and
   the KAM note picker (NoteLinkSelect), and the Audit Trail row of the tick. No standard paragraph is quoted. */
const I18N_S12B = {
  en: {
    s12b: {
      notPresented: {
        title: "Not presented ({n})",
        hint: "These notes have no figures and no text of yours, so they are left out of the statements and the numbering. Tick \"Include\" to present one anyway.",
        include: "Include",
        includeTitle: "Present this note in the statements (it takes the next running number in its place)",
        saved: "Saved — the notes are renumbered.",
        failed: "The change was not saved.",
      },
      report: {
        stale: "Note numbers changed since this version — regenerate.",
      },
      noteLink: {
        typed: "Note: type the number",
        option: "Note {n} · {title}",
        hint: "Pick the note: the report prints the number the financial statements give it when the report is generated.",
      },
    },
    w13: {
      action: { fs_note_include_set: "Note presentation changed (include)" },
      entity: { fs_note: "Note to the financial statements" },
    },
  },
  ar: {
    s12b: {
      notPresented: {
        title: "غير معروضة ({n})",
        hint: "لا تتضمن هذه الإيضاحات أرقامًا ولا نصًا أدخلتموه، لذلك تُستبعد من القوائم ومن الترقيم. حدّد \"تضمين\" لعرض أي منها رغم ذلك.",
        include: "تضمين",
        includeTitle: "عرض هذا الإيضاح في القوائم (يأخذ الرقم التالي في موضعه)",
        saved: "تم الحفظ — أُعيد ترقيم الإيضاحات.",
        failed: "لم يُحفظ التغيير.",
      },
      report: {
        stale: "تغيّرت أرقام الإيضاحات منذ هذا الإصدار — أعد إنشاء التقرير.",
      },
      noteLink: {
        typed: "الإيضاح: اكتب الرقم",
        option: "إيضاح {n} · {title}",
        hint: "اختر الإيضاح: يطبع التقرير رقمه كما ترقّمه القوائم المالية عند إنشاء التقرير.",
      },
    },
    w13: {
      action: { fs_note_include_set: "تغيير عرض إيضاح (تضمين)" },
      entity: { fs_note: "إيضاح حول القوائم المالية" },
    },
  },
};

export default I18N_S12B;
